/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  APPROVE_SALES_QC_REQUEST_SUCCESS,
  APPROVE_SALES_QC_REQUEST,
  APPROVE_SALES_QC_REQUEST_ERROR,
  UPDATE_SALES_QC_REAPPROVE,
  UPDATE_SALES_QC_REAPPROVE_SUCCESS,
  UPDATE_SALES_QC_REAPPROVE_ERROR,
  LOAD_SALES_PENDING,
  LOAD_SALES_PENDING_SUCCESS,
  LOAD_SALES_PENDING_ERROR,
  LOAD_SALES_QC_HISTORY,
  LOAD_SALES_QC_HISTORY_SUCCESS,
  LOAD_SALES_QC_HISTORY_ERROR,
} from "./constants"

export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(salesQcMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    salesQcMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}

///Sales Approval list

/**
 *
 * @param {string} id
 * @param {function} setSubmitting
 * @param {function} redirect
 * @returns
 */
export function approvalSalesRequestQc(id, leadQuotationId, salesId) {
  const leadId = id
  return {
    type: APPROVE_SALES_QC_REQUEST,
    leadId,
    leadQuotationId,
    salesId,
  }
}

/**
 *
 * @param {integer} id
 * @param {string} success
 * @returns
 */
export function approvalSalesRequestQcSuccess(
  id,
  success,
  leadQuotationId,
  salesId
) {
  const leadId = id

  return {
    type: APPROVE_SALES_QC_REQUEST_SUCCESS,
    leadId,
    leadQuotationId,
    salesId,
    success,
  }
}

/**
 * @param {string} error
 */
export function approvalSalesRequestQcError(error) {
  return {
    type: APPROVE_SALES_QC_REQUEST_ERROR,
    error,
  }
}

//Re-approve update API

/**
 *
 * @returns
 */
export function updateSalesQcReapprove(qcUpdateData) {
  return {
    type: UPDATE_SALES_QC_REAPPROVE,
    qcUpdateData,
  }
}

/**
 *
 * @param {integer} id
 * @param {string} success
 * @returns
 */
export function updateSalesQcReapproveSuccess(success, qcUpdateData) {
  return {
    type: UPDATE_SALES_QC_REAPPROVE_SUCCESS,
    qcUpdateData,
    success,
  }
}

/**
 * @param {string} error
 */
export function updateSalesQcReapproveError(error) {
  return {
    type: UPDATE_SALES_QC_REAPPROVE_ERROR,
    error,
  }
}

// Load Sales Pending Approval
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadSalesPending(searchValue) {
  return {
    type: LOAD_SALES_PENDING,
    searchValue
  }
}

export function loadSalesPendingSuccess(sales_pending_details) {
  return {
    type: LOAD_SALES_PENDING_SUCCESS,
    sales_pending_details,
  }
}

/**
 * @param {string} error
 */

export function loadSalesPendingError(error) {
  return {
    type: LOAD_SALES_PENDING_ERROR,
    error,
  }
}

//Qc list
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadSalesQcHistory(id) {
  return {
    type: LOAD_SALES_QC_HISTORY,
    id,
  }
}

export function loadSalesQcHistorySuccess(sales_qc_history) {
  return {
    type: LOAD_SALES_QC_HISTORY_SUCCESS,
    sales_qc_history,
  }
}

/**
 * @param {string} error
 */

export function loadSalesQcHistoryError(error) {
  return {
    type: LOAD_SALES_QC_HISTORY_ERROR,
    error,
  }
}

const actions = {
  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  //sales approve
  approvalSalesRequestQc,
  approvalSalesRequestQcError,
  approvalSalesRequestQcSuccess,

  updateSalesQcReapprove,
  updateSalesQcReapproveSuccess,
  updateSalesQcReapproveError,
  loadSalesPending,
  loadSalesPendingSuccess,
  loadSalesPendingError,
  loadSalesQcHistory,
  loadSalesQcHistorySuccess,
  loadSalesQcHistoryError,
}

export default actions
